import { render, staticRenderFns } from "./HistoriaHabitos.vue?vue&type=template&id=0afa0a94&"
import script from "./HistoriaHabitos.vue?vue&type=script&lang=js&"
export * from "./HistoriaHabitos.vue?vue&type=script&lang=js&"
import style0 from "./HistoriaHabitos.vue?vue&type=style&index=0&id=0afa0a94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports